export const payment = {
  'seo.title': 'Book Consultation — Prices and Programs | Sofia and Elena',
  'seo.description': 'Choose a nutritional support program: VIP support from €500, FMD protocol €35, child nutrition €400, group intensives €250. Book a free diagnostic.',
  'seo.keywords': 'nutritionist prices, consultation cost, book nutritionist, nutrition program prices, VIP support, FMD protocol cost',

  'hero.title': 'Choose your path to health',
  'hero.description': 'Each program is an individual approach and care from two experts',

  'popularChoice': 'Popular Choice',

  'service1.title': 'VIP Support',
  'service1.duration': '1 month',
  'service1.price': '€500',
  'service1.feature1': 'Daily chat support',
  'service1.feature2': 'Analysis review',
  'service1.feature3': 'Individual meal plan',
  'service1.feature4': 'Stress work',
  'service1.feature5': 'Consultations with two experts',

  'service2.title': 'VIP Support',
  'service2.duration': '2 months',
  'service2.price': '€900',
  'service2.feature1': 'Everything from 1 month package',
  'service2.feature2': 'Deep transformation',
  'service2.feature3': 'Family nutrition work',
  'service2.feature4': 'Protocol adjustment',
  'service2.feature5': 'Maximum result',

  'service3.title': 'FMD Protocol',
  'service3.duration': '10 days',
  'service3.price': '€35',
  'service3.feature1': 'Cellular rejuvenation',
  'service3.feature2': 'Detailed 10-day plan',
  'service3.feature3': 'Daily support',
  'service3.feature4': 'Body biohacking',
  'service3.feature5': 'Scientific approach',

  'service4.title': 'Child Nutrition',
  'service4.duration': 'Individual',
  'service4.price': '€400',
  'service4.feature1': 'Work with allergies',
  'service4.feature2': 'Formation of eating habits',
  'service4.feature3': 'Immunity strengthening',
  'service4.feature4': 'Plan for the whole family',
  'service4.feature5': 'Parent support',

  'service5.title': 'Group Intensive',
  'service5.duration': '3-4 people',
  'service5.price': '€190',
  'service5.feature1': 'Community energy',
  'service5.feature2': 'Gentle protocols',
  'service5.feature3': 'Group support',
  'service5.feature4': 'Quick start',
  'service5.feature5': 'Affordable price',

  'service6.title': 'Self-Guided Package',
  'service6.duration': 'One-time service',
  'service6.price': '€150',
  'service6.feature1': 'Detailed analysis review',
  'service6.feature2': 'Deficiency recommendations',
  'service6.feature3': 'Action and nutrition plan',
  'service6.feature4': 'Expert consultation once every 10 days',

  'selected': 'Selected',
  'select': 'Select',
  'selectServiceAria': 'Select {{service}}',

  'form.title': 'Book Consultation',
  'form.description': 'Fill out the form and we\'ll contact you within 24 hours',
  'form.name.label': 'Your Name',
  'form.name.placeholder': 'Enter your name',
  'form.email.label': 'Email',
  'form.email.placeholder': 'your@email.com',
  'form.phone.label': 'Phone',
  'form.phone.placeholder': '+1 (___) ___-____',
  'form.service.label': 'Choose Service',
  'form.service.placeholder': 'Choose service',
  'form.message.label': 'Message',
  'form.message.placeholder': 'Tell us about your goals and wishes (up to 500 characters)',
  'form.message.characters': 'characters',
  'form.submit': 'Submit Request',
  'form.submitting': 'Sending...',
  'form.successMessage': 'Thank you! Your request has been successfully sent. We will contact you shortly.',
  'form.errorMessage': 'An error occurred. Please try again or contact us directly.',

  'cta.title': 'Not sure which program suits you?',
  'cta.description': 'Sign up for a free diagnostic consultation, and we\'ll help you choose the optimal path',
  'cta.button': 'Book Free Consultation',
  'cta.buttonAria': 'Book a free consultation',
};